import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table, Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
// import { useParams } from "react-router-dom";
import { getUserId } from "../services/authorize";

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');
const StudentAvatar = ({ photo, name }) => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const initial = name ? name.trim().charAt(0) : '?';
  const circleStyle = { width: 28, height: 28, borderRadius: '50%', flexShrink: 0 };
  const src = photo ? `${UPLOAD_BASE}${photo.startsWith('/') ? photo : `/${photo}`}` : null;
  return (
    <>
      <span
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
        onMouseEnter={() => src && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => src && setShowModal(true)}
      >
        {src
          ? <img src={src} alt="" style={{ ...circleStyle, objectFit: 'cover', cursor: 'pointer' }} />
          : <span style={{ ...circleStyle, backgroundColor: '#adb5bd', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initial}</span>
        }
        {src && hovered && (
          <div style={{ position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)', zIndex: 1050, background: '#fff', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.25)', padding: 4 }}>
            <img src={src} alt={name} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, display: 'block' }} />
          </div>
        )}
      </span>
      {src && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
          <Modal.Body className="p-3 text-center">
            <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
            {name && <div className="mt-2 fw-semibold small">{name}</div>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default function StudentInAdvice() {

  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary')
        btn.classList.add('btn-white')
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table')
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary')
          thead.classList.add('table-primary')
        }
        table.classList.add('table-dark')
      } else {
        table.classList.remove('table-dark')
        for (const thead of theads) {
          thead.classList.remove('table-primary')
          thead.classList.add('table-secondary')
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  // จัดการ State สำหรับปีการศึกษาและข้อมูลที่โหลดได้
  const [yearList, setYearList] = useState([])
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null
  })

  const [selectedYear, setSelectedYear] = useState("")
  const [data, setData] = useState([]);

  // ดึงรายการปีการศึกษา
  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API}/getStudyYear`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
      .then((res) => {
        const list = res.data;
        setYearList(list || []);
       // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
      let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading])

  const [roomId, setRoomId] = useState(0)  
  useEffect(() => {
    if (!yearId) return;
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomIdByAdvisorId/${getUserId()}/${yearId}`,
    {
      headers: {
            authorization: `Bearer ${getToken()}`
        }
    })
        .then(response => {
            setRoomId(response.data)
            // setIsLoading(false)
            console.log(response.data)
        })
        .catch(err => {
            console.log(err.response.data.message)
            Swal.fire({
                title: err.response.data.title || err.response.statusText,
                text: err.response.data.message || err.message,
                icon: "error"
            })
        }).finally(() => {
          setLoading(false);
        })
    }, [setLoading, yearId]);

  useEffect(() => {
    if (!roomId) return;
    setLoading(true);
        
    axiosInstance.get(`${process.env.REACT_APP_API}/listStudentsInClass/${roomId}`,
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(response.data)
        // setIsLoading(false)
        // console.log(response.data)
      })
      .catch(err => {
        console.log(err.response.data.message)
        Swal.fire({
          title: err.response.data.title || err.response.statusText,
          text: err.response.data.message || err.message,
          icon: "error"
        })
      }).finally(() => {
        setLoading(false);
      })

  }, [setLoading, roomId]);

  // Handle การเปลี่ยนปีการศึกษาจาก Dropdown
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`);
      localStorage.setItem('yearId', id); // <-- เก็บลง LocalStorage
    }
  }

  const handleUpdateStatus = (studentId, newStatus) => {
    setLoading(true);
    axiosInstance.post(
      `${process.env.REACT_APP_API}/updateStudentStatus`,
      { student_id: studentId, st_status: newStatus },
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    )
      .then(response => {
        Swal.fire({
          title: 'สำเร็จ',
          text: 'อัปเดตสถานะนักเรียนสำเร็จ',
          icon: 'success'
        });
        // Refresh the data
        setData(data.map(student => 
          student.st_id === studentId 
            ? { 
                ...student, 
                st_status: newStatus, 
                status_text: newStatus === '1' ? 'กำลังศึกษาอยู่' : newStatus === '0' ? 'จำหน่ายแล้ว' : 'นักเรียนใหม่'
              }
            : student
        ));
      })
      .catch(err => {
        Swal.fire({
          title: err.response?.data?.title || 'เกิดข้อผิดพลาด',
          text: err.response?.data?.message || err.message,
          icon: 'error'
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item">
                <Link to="#">ข้อมูลประจำชั้น</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                ข้อมูลนักเรียนทั้งหมดในห้องเรียน
              </li>
            </ol>
            <h4 className="main-title mb-0">ข้อมูลนักเรียนทั้งหมดในห้องเรียน</h4>
          </div>
      
          {/* Dropdown เลือกปีการศึกษา */}
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
          
              <Dropdown.Menu>
                {yearList.map((item) => (
                <Dropdown.Item
                  key={item.year_id}
                  onClick={() => handleSelectYear(item.year_id)}
                >
                  {`ปีการศึกษา ${item.year_year}`}
                </Dropdown.Item>
              ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              {/* <Card.Header>
                <Card.Title as="h6">รายชื่อนักเรียนชั้น ม. {c_class + '/' + r_no}</Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header> */}
              <Card.Body className="p-3">
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width:"50px" }}>เลขที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>เลขประจำตัว</th>
                      <th scope="col">ชื่อ-สกุล</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>ช้ันศาสนา</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>หอพัก</th>
                      <th scope="col" className="text-center" style={{ width: "150px" }}>สถานะ</th>
                      <th scope="col" className="text-center" style={{ width: "150px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                  {data && data.length > 0 ? (
                  data.map((data, index) => (
                      <tr key={data.st_id} className={data.st_status === '0' ? 'table-danger' : data.transfer_room_id ? 'table-warning' : ''}>
                        <th scope="row" className="text-center">{++index}</th>
                        <td className="text-center">{data.st_idnumber}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <StudentAvatar photo={data.st_photo} name={data.st_name} />
                            <span>
                              {data.st_name}
                              {data.transfer_room_id && (
                                <small className="text-muted ms-2">(ย้ายไป ม.{data.transfer_class_id}/{data.transfer_room_no})</small>
                              )}
                            </span>
                          </div>
                        </td>
                        <td className="text-center">{data.ic_class ? `${data.ic_class}/${data.isl_room_no}` : '-'}</td>
                        <td className="text-center">{data.dorm_name || '-'}</td>
                        <td className={data.st_status === '0' 
                            ? 'text-center text-danger' 
                            : data.st_status === '1'
                            ? 'text-center text-primary'
                            : 'text-center text-success'
                        }>
                          <div className="d-flex gap-2 justify-content-center">
                            {data.status_text}
                            <Dropdown>
                              <Dropdown.Toggle 
                                as="span" 
                                className="d-inline"
                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                title="แก้ไขสถานะ"
                              >
                              </Dropdown.Toggle>
                              <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={() => handleUpdateStatus(data.st_id, '1')}>
                                  <i className="ri-check-line text-primary"></i> กำลังศึกษาอยู่
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleUpdateStatus(data.st_id, '0')}>
                                  <i className="ri-close-line text-danger"></i> จำหน่ายแล้ว
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleUpdateStatus(data.st_id, '3')}>
                                  <i className="ri-user-shared-line text-success"></i> นักเรียนใหม่
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                        <td className="text-center">
                            <Link to={`/advisor/student-info/${data.st_id}`}><i className="ri-contacts-book-2-line"> แสดงข้อมูลนักเรียน</i></Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}